import script from "./GroupPage.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupPage.vue?vue&type=script&setup=true&lang=js"

import "./GroupPage.vue?vue&type=style&index=0&id=013de66e&scoped=true&lang=css"

import exportComponent from "/Users/tannerwelton/Development/zulu-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-013de66e"]])

export default __exports__